import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators, FormArray, AbstractControl } from '@angular/forms';
import { FswService } from '@services/fsw.service';

import { Router } from "@angular/router";
import { FileUploader, FileSelectDirective } from 'ng2-file-upload';
//import { Ng2ImgMaxService } from 'ng2-img-max';
import { DomSanitizer } from '@angular/platform-browser';
import { AuthService } from '@services/auth.service';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { NgxSpinnerService } from "ngx-spinner"; 
import { environment } from '../../../environments/environment';
import {ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-add-awp',
  templateUrl: './add-awp.component.html',
  styleUrls: ['./add-awp.component.scss']
})
export class AddAwpComponent implements OnInit {
  myInputVariable!: ElementRef;
  programAddForm!: FormGroup;
  submitted = false;
  success = false;
  uploadedImage!: File;
  imagePreview: any;
  fileName!: File;
  jsonObject: any = {};
  userName: any;
  awp_id: any;
  awpFileUploadsData: { awpId: number; createdBy: string; } | undefined;
  message: any;
  saveType: any;

  awpRecordData!: any[];
  p: number = 1;
  itemsPerPage : number = 10;
  arr: any;
  docs: any = [];
  images: any = [];
  fileInfos:any = [];
  private apiURL = environment.apiURL;
  districtRecord : any[] | undefined;
  selectedDistrict: any = null;
  fileFlag: boolean = false;
  gpsLocation_data!: any;

  constructor(private formBuilder: FormBuilder, private router: Router, private data: FswService, private authService: AuthService, public sanitizer: DomSanitizer, private spinnerService: NgxSpinnerService, private toastr: ToastrService) { }
  //public uploader: FileUploader = new FileUploader({ url: URL, itemAlias: 'photo' });
  get f(): { [key: string]: AbstractControl } {
    return this.programAddForm.controls;
  }


  ngOnInit(): void {
    debugger;
    this.programAddForm = this.formBuilder.group({
      programTitle: ['', Validators.required],
      programDesc: ['', [Validators.required,Validators.maxLength(1000)]],
      noOfTrainees: ['', [Validators.required, Validators.pattern("^[0-9]*$")]],
      trainerName: ['', Validators.required],
      gpsLocation: ['', Validators.required],
      venue: ['', Validators.required],
      remarks: [''],
      createdBy: [''],
      districtCode: ['', Validators.required],
      programDate: ['', Validators.required],
      activeFlag: [''],
      // options: this.formBuilder.array([new FormControl()])
    });
    this.getDistrict();
    this.getLocation();
    //this.awpRecordData = this.data.getawpFile();
    //let obj = this.fileInfos.filter((m: { awpId: any; }) => (m.awpId == this.awp_id));
    //this.fileInfos = obj; 
  }

  onSubmit() {
    debugger;
    
    console.log(this.saveType);
    this.submitted = false;
    this.spinnerService.show();
    if (this.awp_id) {
      if (this.fileFlag) {
      var userName = '';
      userName = this.authService.getUserName();
      this.awpFileUploadsData =
      {
        "awpId": this.awp_id,
        "createdBy": userName

      }
      var json = JSON.stringify(this.awpFileUploadsData);
      const formData = new FormData();
      // formData = this.awpAddForm.value

      formData.append('file', this.fileName);
      formData.append('awpFileUploadsData', json);
      //
      this.data.saveawpFile(formData)
        .subscribe(
          response => {
            debugger;
            this.getawpFileData(this.awp_id);
            this.spinnerService.hide();
            this.success=true;
            
           // this.toastr.success('Awareness Program Data Added Successfully!');
          },
          error => {
            this.toastr.error('Error Occured!');
            console.log(error);
            this.spinnerService.hide();
          });
        }
        else 
        {
          this.toastr.error('Please Upload Atleast One File!');
          this.spinnerService.hide();
          return;
        }

    }
    else {
      if (this.fileName) {
      this.userName = this.authService.getUserName();
      this.programAddForm.controls['createdBy'].setValue(this.userName)
      this.programAddForm.controls['activeFlag'].setValue('N');
      var json = JSON.stringify(this.programAddForm.value);
      const formData = new FormData();
      formData.append('file', this.fileName);
      formData.append('awarenessProgramData', json);
      this.data.saveawpData(formData)
        .subscribe(
          response => {
            this.awp_id = response.awpId;
            this.getawpFileData(this.awp_id);
            this.spinnerService.hide();
            this.success=true;
            this.fileFlag = true;
          // this.toastr.success('Awareness Program Data Added Successfully!');
          },
          error => {
            this.toastr.error('Error Occured!');
            console.log(error);
            this.spinnerService.hide();
          });

      //this.success = true;

    }
    else 
        {
          this.toastr.error('Please Select File!');
          this.spinnerService.hide();
          return;
        }
  }
  
}
  getawpFileData(awpId: any) {
    this.spinnerService.show();
    this.fileInfos = [];
    this.data.getAwpFileUploadsWithAwpId(awpId)
      .subscribe(res => {
      debugger
      this.arr = res;
      this.arr.forEach((item: any) => {
        let filename = item.filePath.replace(/^.*[\\\/]/, '')
        item.filename = filename;
        this.fileInfos.push({filename:item.filename, id:item.id,filepath:this.apiURL+'/fsw/document-view'+item.filePath})
       
        if (item.filePath.includes('jpg') || item.filePath.includes('jpeg') || item.filePath.includes('png')){
          this.images.push({filename:item.filename,filepath:this.apiURL+'/fsw/document-view'+item.filePath} )
         
        }
        else{
          this.docs.push({filename:item.filename,filepath:this.apiURL+'/fsw/document_view'+item.filePath} )
        }
        this.spinnerService.hide();
      })
      });
  }
  onFileSelect(event: any) {
    debugger
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (file) {
        if (file.type == "application/pdf" || file.type == "image/jpeg" || file.type == "image/jpg" || file.type == "image/png") {
          debugger
          if (file.size < 10485760) {
            debugger
            this.fileName = file;
          }
          else {
            this.myInputVariable.nativeElement.value = null;
            //var filesizeBtn = confirm("File should be in 10 mb.");
            //if (filesizeBtn == true) {
            //}
            //alert("File size should not exceed 10 mb");
            this.toastr.error('File size should not exceed 10 mb');
          }
        }
        else {
          this.myInputVariable.nativeElement.value = null;
          //var fileFormatBtn = confirm("File Type should be in pdf or jpg format.");
          //  if (fileFormatBtn == true) {
          //  }
          this.toastr.error('You can only upload pdf and image');
          
        }

      }
    }
  }

  // onImageChange(event) {
  //   let image = event.target.files[0];

  //   this.ng2ImgMax.resizeImage(image, 750, 400).subscribe(
  //     result => {
  //       this.uploadedImage = new File([result], result.name);
  //       this.getImagePreview(this.uploadedImage);
  //     },
  //     error => {
  //       console.log('😢 Oh no!', error);
  //     }
  //   );
  // }

  // getImagePreview(file: File) {
  //   const reader: FileReader = new FileReader();
  //   reader.readAsDataURL(file);
  //   reader.onload = () => {
  //     this.imagePreview = reader.result;
  //   };
  // }

  updateInsertData() {
    debugger;
    if(this.fileName)
    {
      this.fileFlag=true;
    }
    if (this.fileFlag) {
    this.submitted = true;
    this.spinnerService.show();
    if (this.programAddForm.invalid) {
      this.spinnerService.hide();
      return;
      
    }
    if (this.awp_id) {
      this.userName = this.authService.getUserName();
      this.programAddForm.controls['createdBy'].setValue(this.userName);
      this.programAddForm.controls['activeFlag'].setValue('Y');
      var json = JSON.stringify(this.programAddForm.value);
      const formData = new FormData();
      formData.append('file', this.fileName);
      formData.append('awareProgramData', json);
      this.data.updateawpData(this.awp_id, formData)
        .subscribe(
          response => {
            this.submitted = false;
            this.programAddForm.reset({});
            this.awpRecordData = [];
            this.fileInfos = [];
            this.spinnerService.hide();
            this.toastr.success('Awareness Program Data Added Successfully!');
            this.router.navigate(['list-awp']);
          },
          error => {
            this.toastr.error('Error Occured!');
            console.log(error);
            this.spinnerService.hide();
          });
    }
    else {
      this.userName = this.authService.getUserName();
      this.programAddForm.controls['createdBy'].setValue(this.userName);
      this.programAddForm.controls['activeFlag'].setValue('Y');
      var json = JSON.stringify(this.programAddForm.value);
      const formData = new FormData();
      formData.append('file', this.fileName);
      formData.append('awarenessProgramData', json);
      this.data.saveawpData(formData)
        .subscribe(
          response => {
            this.submitted = true;
            this.programAddForm.reset({});
            this.awpRecordData = [];
            this.fileInfos = [];
            this.spinnerService.hide();
            this.toastr.success('Awareness Program Data Added Successfully!');
            this.router.navigate(['list-awp']);
            
          },
          error => {
            this.toastr.error('Error Occured!');
            console.log(error);
            this.spinnerService.hide();
          });

      //this.success = true;

    }
    this.getawpFileData(this.awp_id);
  }
  else 
        {
          this.toastr.error('Please Select Atleast One File!');
          this.spinnerService.hide();
          return;
        }
  }
  deleteRow(x: any)
  {
    debugger
    var delBtn = confirm(" Do you want to delete ?");
    if ( delBtn == true ) {
      this.spinnerService.show();
      this.data.deleteAwpFileUploadsWithAwpId(x.id)
      .subscribe(res => {
      debugger
         this.getawpFileData(this.awp_id)
         this.spinnerService.hide();
         this.toastr.success('File Deleted Successfully!');
      });
    }   
  }
  getDistrict(){
    debugger
    var stateCode = '';
    stateCode = this.authService.getState();
    this.data.getDistrict(stateCode).subscribe(
      (Districtdata) =>
      {
        this.districtRecord = Districtdata;
      }
    )
  }
  getLocation(){
    debugger
 
   if (navigator.geolocation) {
     navigator.geolocation.getCurrentPosition(function(position) {
       if (position) {
         console.log(position)
       // this.lat = position.coords.latitude;
       // this.lng = position.coords.longitude;
       var lats = position.coords.latitude;
       var lngs = position.coords.longitude;
       //this.lat = 
      //  console.log("Lattitude is "+ lats + " longitude is " + lngs);
       var gpsLocation_data_var = lats + ", "+lngs;
       this.gpsLocation_data = gpsLocation_data_var;
       console.log(this.gpsLocation_data);
       /* console.log(gpsLocation_data_var);
       this.trainingAddForm.controls['gpsLocation'].setValue(gpsLocation_data_var);
       this.gpsLocation_data = gpsLocation_data_var; */
     //   this.getAddress=(this.lats,this.lngs)
     //let location = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);
 
      //   this.apiloader.load().then(() => {
      //     let geocoder = new google.maps.Geocoder;
      //     let latlng = {lat: lats, lng: lngs};
        
      //     geocoder.geocode({'location': latlng}, function(results) {
      //         if (results[0]) {
      //           this.currentLocation= results[0].formatted_address;
              
      //         console.log(this.currentLocation);
      //         } else {
      //           console.log('Not found');
      //        }
 
         
      //     });
      // });
 
 
     }
   })
 }
 
 }

}
